import { APIDOMAIN, apiEndpoint } from '@ibinder/common-utils';
import { getAppSetting } from 'Shared/ApplicationSettings';

const apiEndpointFor = apiEndpoint(getAppSetting('REACT_APP_API_URL'));
const {
  issues,
  inspections,
  binders,
  users,
  customers,
  admin,
  facilities,
  etendering,
  documents,
  bookshelves,
  activities,
  contracts,
  conversations,
  legacyBinders,
  legacyOrganization,
  localization,
  localization_my_ibinder,
  maintenances,
  metadata,
  properties
} = APIDOMAIN;

export const CustomersApi = apiEndpointFor(customers);
export const IssuesApi = apiEndpointFor(issues);
export const InspectionsApi = apiEndpointFor(inspections);
export const BindersApi = apiEndpointFor(binders);
export const UsersApi = apiEndpointFor(users);
export const AdminApi = apiEndpointFor(admin);
export const FacilitiesApi = apiEndpointFor(facilities);
export const EtenderingApi = apiEndpointFor(etendering);
export const DocumentsApi = apiEndpointFor(documents);
export const BookshelvesApi = apiEndpointFor(bookshelves);
